import { JSONType } from 'Typings/Global';
import { Tag } from './@types';

// eslint-disable-next-line import/prefer-default-export
export const parseTag = (res: JSONType): Tag =>
  ({
    ...res,
  } as Tag);
